/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import HistoryIcon from "@mui/icons-material/History";
import {
  AD_FRAMEWORK_JIRA_TICKET_MSG,
  AD_FRAMEWORK_TYPE,
  API_JIRA_TICKET_MSG,
  API_TYPE,
  APPLICATION_JIRA_TICKET_MSG,
  APPLICATION_TYPE,
  COLLECTOR_DISABLED_BUTTON,
  COLLECTOR_ENABLED_BUTTON,
  CREATE_JIRA_TICKET_BTN,
  DISABLE_AD_FRAMEWORK,
  DISABLE_MEDIA_PLAYER,
  ENABLE_AD_FRAMEWORK,
  ENABLE_MEDIA_PLAYER,
  MEDIA_PLAYER_JIRA_TICKET_MSG,
  MEDIAPLAYER_TYPE,
} from "../../app/Constants/Constants";

export const collectorListBO = /* istanbul ignore next */ (collector) => {
  let obj = {};
  obj = {
    ...obj,
    api: collector?.api?.map((apiList) => ({
      type: API_TYPE,
      name: apiList.collectorName,
      id: apiList.id,
      status: apiList.status,

      key: apiList.collectorKey,
      mediaPlayer: apiList.mediaPlayer,
      currentVersion: apiList.currentVersion,
      jiraIntegrationStatus: apiList.jiraTicketsCreated,
    })),
  };
  obj = {
    ...obj,
    application: collector?.application?.map((appList) => {
      let mediaPlayers = [];
      let adFrameworks = [];
      if (appList?.mediaPlayers?.length > 0) {
        mediaPlayers = appList.mediaPlayers.map((mediaPlayer) => ({
          type: MEDIAPLAYER_TYPE,
          name: mediaPlayer.collectorName,
          id: mediaPlayer.id,
          status: mediaPlayer.status,

          key: mediaPlayer.collectorKey,
          supportCmcd: mediaPlayer.supportCmcd,
          supportSampling: mediaPlayer.supportSampling,
          supportAppSessionTimeOut: mediaPlayer.supportAppSessionTimeOut,
          jiraIntegrationStatus: mediaPlayer.jiraIntegrationStatus,
          //   mediaStaus :mediaPlayer,
        }));
      }
      if (appList?.adFrameworks?.length > 0) {
        adFrameworks = appList.adFrameworks.map((adFramework) => ({
          type: AD_FRAMEWORK_TYPE,
          name: adFramework.name,
          id: adFramework.id,

          key: adFramework.key,
          supportSampling: adFramework.supportSampling,
          supportAppSessionTimeOut: adFramework.supportAppSessionTimeOut,
          jiraIntegrationStatus: adFramework.jiraTicketsCreated,
          status: adFramework.status,
          //   adFramework,
        }));
      }
      return {
        type: APPLICATION_TYPE,
        id: appList.applicationId,
        name: appList.applicationName,

        key: appList.applicationKey,
        supportSampling: appList.supportSampling,
        supportAppSessionTimeOut: appList.supportAppSessionTimeOut,
        jiraIntegrationStatus: appList.jiraIntegrationStatus,
        mediaPlayers,
        adFrameworks,
        currentVersion: appList.currentVersion,
        status: appList.status,
      };
    }),
  };
  return obj;
};
export const getListViewObj = /* istanbul ignore next */ (collector) => {
  let obj = {};
  obj = {
    ...obj,
    api: collector?.api?.map((apiList) => ({
      type: API_TYPE,
      name: apiList.collectorName,
      id: apiList.id,
      status: apiList.status,
    })),
  };
  obj = {
    ...obj,

    application: collector?.application?.map((appList) => {
      const mediaPlayers =
        appList?.mediaPlayers?.map((mediaPlayer) => ({
          type: MEDIAPLAYER_TYPE,
          name: mediaPlayer.collectorName,
          id: mediaPlayer.id,
          application: appList,
          status: mediaPlayer.status,
          adFrameworks:
            mediaPlayer?.adFrameworks?.map((adFramework) => ({
              type: AD_FRAMEWORK_TYPE,
              name: adFramework.name,
              id: adFramework.id,
              status: adFramework.status,
              application: appList,
              mediaPlayer: mediaPlayer.collectorName,
              mediaPlayerId: mediaPlayer.id,
            })) || [],
        })) || [];

      return {
        type: APPLICATION_TYPE,
        id: appList.id,
        name: appList.collectorName,
        status: appList.status,
        mediaPlayers,
      };
    }),
  };

  return obj;
};

export const collectorToggleIcon = (sectionName) => [
  { icon: <LibraryBooksIcon />, value: 0, name: `${sectionName}` },
  {
    icon: <HistoryIcon />,
    value: 1,
    name: "Change Log",
  },
];
export const collectorMgmtDialogDetails = (
  statusType,
  type,
  status,
  name,
  collectorTitleName,
  supportSampling,
  appSessionTimeOut,
  cmcdStatus,
  collectorDetails,
  visibility,
) => {
  switch (statusType) {
    case "status": {
      const actionName = status ? "Disable" : "Enable";
      const actionTypeTitle =
        type === MEDIAPLAYER_TYPE
          ? "extention"
          : type === AD_FRAMEWORK_TYPE
          ? "ad framework"
          : "collector";
      const actionType =
        type === MEDIAPLAYER_TYPE
          ? "media player"
          : type === AD_FRAMEWORK_TYPE
          ? "ad framework"
          : "collector";
      const actionButtonlabel = `${actionName} ${actionType}`;
      const actionContent =
        type === APPLICATION_TYPE
          ? "An email will be sent to users from accounts that have a collector configuration associated with this collector."
          : `An email will be sent to users from accounts that have a ${collectorTitleName} using ${name} collector configuration.`;

      return {
        title: `${actionName} the ${name} ${actionTypeTitle}?`,
        content: actionContent,
        actionButtonNames: [actionButtonlabel, "cancel"],
      };
    }
    case "supportSampling": {
      const actionName = supportSampling ? "Disable" : "Enable";
      const actionTypeTitle =
        type === MEDIAPLAYER_TYPE
          ? "extention"
          : type === AD_FRAMEWORK_TYPE
          ? "ad framework"
          : "collector";
      const actionButtonlabel = `${actionName} sampling`;
      const actionContent =
        type === APPLICATION_TYPE
          ? "An email will be sent to users from accounts that have a collector configuration associated with this collector."
          : `An email will be sent to users from accounts that have a ${collectorTitleName} using ${name} collector configuration.`;

      return {
        title: `${actionName} sampling for the ${name} ${actionTypeTitle}?`,
        content: actionContent,
        actionButtonNames: [actionButtonlabel, "cancel"],
      };
    }
    case "appSessionTimeOut": {
      const actionName = appSessionTimeOut ? "Disable" : "Enable";
      const actionButtonlabel = `${actionName} configurable timeout`;
      const actionContent =
        type === APPLICATION_TYPE
          ? "An email will be sent to users from accounts that have a collector configuration associated with this collector."
          : `An email will be sent to users from accounts that have a ${collectorTitleName} using ${name} collector configuration.`;

      return {
        title: `${actionName} configurable app session timeout for the ${name} collector?`,
        content: actionContent,
        actionButtonNames: [actionButtonlabel, "cancel"],
      };
    }
    case "cmcdStatus": {
      const actionName = cmcdStatus ? "Disable" : "Enable";
      const actionButtonlabel = `${actionName} cmcd`;
      const actionContent =
        type === APPLICATION_TYPE
          ? "An email will be sent to users from accounts that have a collector configuration associated with this collector."
          : "An email will be sent to users from accounts that have a collector configuration associated with this media player.";

      return {
        title: `${actionName} CMCD for ${name} on the ${collectorTitleName}?`,
        content: actionContent,
        actionButtonNames: [actionButtonlabel, "cancel"],
      };
    }
    case "Jira Integration": {
      const actionTitle =
        type === APPLICATION_TYPE || type === API_TYPE
          ? `Create Jira tickets for the ${name} collector?`
          : type === MEDIAPLAYER_TYPE
          ? `Create Jira tickets for ${name} on the ${collectorDetails?.application?.name} collector?`
          : `Create Jira tickets for ${name} of the ${collectorDetails?.application?.name}'s ${collectorDetails?.adFramework.mediaPlayerName}?`;

      const actionButtonlabel = CREATE_JIRA_TICKET_BTN;
      const actionContent =
        type === APPLICATION_TYPE
          ? APPLICATION_JIRA_TICKET_MSG
          : type === API_TYPE
          ? API_JIRA_TICKET_MSG
          : type === MEDIAPLAYER_TYPE
          ? MEDIA_PLAYER_JIRA_TICKET_MSG
          : AD_FRAMEWORK_JIRA_TICKET_MSG;

      return {
        title: actionTitle,
        content: actionContent,
        actionButtonNames: actionButtonlabel,
      };
    }
    case "visibility": {
      const actionName = visibility ? "Off" : "On";
      const actionButtonlabel = `Turn ${actionName} visibility`;
      const actionContent = visibility
        ? `This ${name} collector will not be available to users other than Super Admins`
        : `This ${name} collector will be available to all users.`;

      return {
        title: `Visibility ${actionName} for the ${name} collector?`,
        content: actionContent,
        actionButtonNames: [actionButtonlabel, "cancel"],
      };
    }

    // default:
    //   return;
  }
};
export const updateCollectorMgmtBO = (value, data) => {
  const updatedValue = {
    id: value?.collector?.collectorId || value?.collector?.componentId,
    status: value?.collector?.status,
    supportSampling: value?.collector?.supportSampling,
    type: value.type,
    supportAppSessionTimeOut: value?.collector?.appSessionTimeOut,
    supportCmcd: value?.collector?.cmcdStatus,
    name: value?.collector?.name,
    visibility: value?.collector?.visibility,
  };
  return updatedValue;
};
// export const collectorMgmtStateUpdation = (currentState, newData) => {
//   const {
//     type,
//     status,
//     name,
//     supportSampling,
//     supportAppSessionTimeOut,
//     supportCmcd,
//   } = newData;
//   const updatedState = { ...currentState };
//   switch (type) {
//     case APPLICATION_TYPE:
//       if (updatedState.application) {
//         updatedState.application = {
//           ...updatedState.application,
//           status:
//             status !== undefined ? status : updatedState.application.status,
//           name: name !== undefined ? name : updatedState.application.name,
//           supportSampling:
//             supportSampling !== undefined
//               ? supportSampling
//               : updatedState.application.supportSampling,
//           supportAppSessionTimeOut:
//             supportAppSessionTimeOut !== undefined
//               ? supportAppSessionTimeOut
//               : updatedState.application.supportAppSessionTimeOut,
//         };
//       }
//       break;
//     case MEDIAPLAYER_TYPE:
//       if (updatedState.mediaPlayer) {
//         updatedState.mediaPlayer = {
//           ...updatedState.mediaPlayer,
//           status:
//             status !== undefined ? status : updatedState.mediaPlayer.status,
//           name: name !== undefined ? name : updatedState.mediaPlayer.name,
//           supportCmcd:
//             supportCmcd !== undefined
//               ? supportCmcd
//               : updatedState.mediaPlayer.supportCmcd,
//         };
//       }
//       break;
//     case AD_FRAMEWORK_TYPE:
//       if (updatedState.adFramework) {
//         updatedState.adFramework = {
//           ...updatedState.adFramework,
//           status:
//             status !== undefined ? status : updatedState.adFramework.status,
//           name: name !== undefined ? name : updatedState.adFramework.name,
//         };
//       }
//       break;
//     default:
//   }

//   return updatedState;
// };

export const collectorMgmtStateUpdation = (currentState, newData) => {
  const {
    type,
    status,
    name,
    supportSampling,
    supportAppSessionTimeOut,
    supportCmcd,
    visibility,
  } = newData;

  const updatedFields = {
    status,
    name,
    supportSampling,
    supportAppSessionTimeOut,
    supportCmcd,
    visibility,
  };
  const updatedState = { ...currentState };
  const updateSection = (section) => {
    if (updatedState[section]) {
      updatedState[section] = {
        ...updatedState[section],
        ...Object.fromEntries(
          Object.entries(updatedFields).filter(
            ([key, value]) => value !== undefined,
          ),
        ),
      };
    }
  };
  switch (type) {
    case APPLICATION_TYPE:
      updateSection("application");
      break;
    case API_TYPE:
      updateSection("api");
      break;
    case MEDIAPLAYER_TYPE:
      updateSection("mediaPlayer");
      break;
    case AD_FRAMEWORK_TYPE:
      updateSection("adFramework");
      break;
    default:
      break;
  }

  return updatedState;
};

export const identifyChanges = (oldData, newData, sectionName) => {
  return Object.keys(oldData).reduce((changes, key) => {
    if (oldData[key] !== newData[key]) {
      changes.push({
        field: key,
        value: newData[key],
        sectionName,
      });
    }
    return changes;
  }, []);
};

export const getCollectorMgmtMessage = (
  field,
  sectionName,
  value,
  detailsValue,
  CollectortitleName,
  name,
) => {
  const messages = {
    supportSampling: value
      ? `Sampling is enabled for the ${detailsValue.name} collector`
      : `Sampling is disabled for the ${detailsValue.name} collector`,
    status: value
      ? `${sectionName} Status Enabled`
      : `${sectionName} Status Disabled`,
    supportAppSessionTimeOut: value
      ? `Configurable app session timeout is enabled for the ${detailsValue.name} collector`
      : `Configurable app session timeout is disabled for the ${detailsValue.name} collector`,
    supportCmcd: value
      ? `CMCD is enabled for ${detailsValue.name} on ${CollectortitleName}`
      : `CMCD is disabled for ${detailsValue.name} on ${CollectortitleName}`,

    visibility: value
      ? `Visibility is turned on for the ${detailsValue.name}`
      : `Visibility is turned off for the ${detailsValue.name}`,
  };
  return messages[field] || `${name} Updated`;
};

export const getTypeWithIdForApi = (value) => {
  return value.type === APPLICATION_TYPE || value.type === API_TYPE
    ? { collectorId: value.id }
    : {
        componentId: value.id,
        componentType:
          value.type === MEDIAPLAYER_TYPE ? "MediaPlayer" : "AdFramework",
      };
};

export const collectorLogsTable = [
  {
    key: "fieldName",
    label: "Field",
  },
  {
    key: "previousValue",
    label: "Previous Value",
  },
  {
    key: "newValue",
    label: "New Value",
  },
];
export const getSupportedList = (players, sortOrder) => {
  const list = players?.map((player) => ({
    status: {
      value: player?.status === true ? null : true,
      view: "status",
    },
    Name: {
      value: player?.name,
    },
  }));

  return list?.sort((a, b) => {
    return sortOrder
      ? a?.Name?.value?.localeCompare(b?.Name?.value)
      : b?.Name?.value?.localeCompare(a?.Name?.value);
  });
};

export const supportedTitles = [
  {
    key: "status",
    label: "status",
    sortable: true,
    sortKey: "staus",
  },
  {
    key: "Name",
    label: "Name",
    sortable: true,
    sortKey: "Name",
  },
];
export const filterBoxCollMgmt = (
  type,
  popUp,
  collectorSupportListDataInitial,
  initialFilter,
  list,
) => {
  const getListByType = (type) => {
    const item = initialFilter.find((i) => i.type === type);
    let listData = item?.previousList?.length ? item.previousList : list || [];
    if (
      (!item?.previousList || item.previousList.length === 0) &&
      type === "dataPointUiGroup"
    ) {
      const categoryItem = initialFilter.find((i) => i.type === "Category");
      if (categoryItem?.previousList?.length) {
        listData = categoryItem.previousList;
      }
    }

    return generateUniqueListsByType(listData, keyMappingClMgmnt)[type];
  };

  const DataPointType = getListByType("datapointType");
  const DataPointCategory = getListByType("dataPointUiGroup");
  const Supported = getListByType("supported");

  /* istanbul ignore if */
  const sortCaseInsensitive = (a, b) => {
    return a?.localeCompare(b, undefined, { sensitivity: "base" });
  };
  DataPointCategory?.sort(sortCaseInsensitive);
  Supported?.sort(sortCaseInsensitive);

  const generateId = () => Math.random().toString(36).slice(2, 7);

  const createDPValue = (items, typeValue) =>
    items?.map((item) => ({
      id: item,
      name: item,
      type: typeValue,
    }));

  const DPList = [];
  DPList.push({
    name: "Category",
    DPValue: createDPValue(DataPointCategory, "dataPointUiGroup"),
    quickFilter: true,
  });
  DPList.push({
    name: "Type",
    DPValue: createDPValue(DataPointType, "datapointType"),
    quickFilter: true,
  });
  if (type === "mediaPlayer") {
    DPList.push({
      name: "Data Point Category",
      DPValue: createDPValue(DataPointCategory, "dataPointUiGroup"),
    });
  }
  if (!popUp) {
    DPList.push({
      name: "Supported",
      DPValue: createDPValue(Supported, "supported"),
      quickFilter: true,
    });
  }

  return {
    DPList: DPList?.filter((filter) => filter?.DPValue?.length > 0),
  };
};

const titlesDataPointsPopUP = [
  {
    key: "NameTp",
    label: "Name",
    sortable: true,
    sortKey: "name",
  },
  {
    key: "Type",
    label: "Type",
    sortable: true,
    sortKey: "type",
  },
  {
    key: "Category",
    label: "Category",
    sortable: true,
    sortKey: "group",
  },
  {
    key: "supported",
    label: "supported",
    sortable: true,
    sortKey: "supported",
  },
];

export const getSupportedDataPointsTitles = (type, Overlay) => {
  let titles = [...titlesDataPointsPopUP];
  /* istanbul ignore if */
  if (type === "adFramework") {
    titles = titles.filter((item) => item.key !== "Category");
  }
  if (Overlay) {
    titles = titles.filter((item) => item.key !== "supported");
  }
  return titles;
};

export const getMediaPlayerList = (player) => {
  const obj = {
    status: {
      value: player?.supported,
      view: "status",
    },
    NameTp: {
      value: player?.name,
      messageName: player?.messageName,
      tooltip: player?.messageName,
      deprecated: player?.deprecated,
    },
    Type: {
      value: player?.type,
    },
    Category: {
      value:
        player?.group === "Events" || player?.group === "FluxData"
          ? "  --  "
          : player?.group,
    },
    media_type: {
      value: player?.mediaType?.toLowerCase(),
    },
    supported: { value: player?.supported || player?.status ? "Yes" : "No" },
  };
  return obj;
};

export const updateSelectedList = (list, selected) => {
  const updatedItems = list.filter(
    (item) =>
      !selected?.some(
        (selectedItem) => selectedItem?.Name?.value === item?.Name?.value,
      ) ||
      selected?.some(
        (selectedItem) =>
          selectedItem?.Name?.value === item?.Name?.value &&
          selectedItem?.Name?.value !== item?.Name?.value,
      ),
  );
  const removedItems = selected?.filter(
    (item) => !list?.some((newItem) => newItem?.value === item?.value),
  );
  const updatedSelected = [
    ...(selected?.filter((item) => !removedItems?.includes(item)) || []),
    ...updatedItems,
  ];
  return updatedSelected;
};
/* istanbul ignore next */
export const getActiveStatusMessage = (
  type,
  collectorName,
  collectorDetails,
) => {
  /* istanbul ignore if */
  if (type === "mediaPlayer") {
    return `Disabling the media player extension will remove it as a selectable media player option from the ${collectorName} collector`;
  }
  if (type === "adFramework") {
    /* istanbul ignore if */
    return `Disabling the ad framework extension will remove it as a selectable ad framework option from the ${collectorDetails?.adFramework?.mediaPlayerName}  on ${collectorName}.`;
  }
};
/* istanbul ignore next */
export const getInActiveStatusMessage = (
  type,
  collectorName,
  collectorDetails,
) => {
  /* istanbul ignore if */
  if (type === "mediaPlayer") {
    return `Enabling the media player extension will add it as a selectable media player option for the ${collectorName} collector.`;
  }
  if (type === "adFramework") {
    /* istanbul ignore if */
    return `Enabling the ad framework extension will add it as a selectable ad framework option for the ${collectorDetails?.adFramework?.mediaPlayerName} on ${collectorName} collector.`;
  }
};

export const getCollectorStatusButtonMessage = (type, status) => {
  if (type === "adFramework") {
    return status ? DISABLE_AD_FRAMEWORK : ENABLE_AD_FRAMEWORK;
  }
  if (type === "mediaPlayer") {
    return status ? DISABLE_MEDIA_PLAYER : ENABLE_MEDIA_PLAYER;
  }
  if (type === "application" || type === "api") {
    return status ? COLLECTOR_ENABLED_BUTTON : COLLECTOR_DISABLED_BUTTON;
  }
};

export const keyMappingClMgmnt = {
  datapointName: {
    matchKey: "NameTp",
    returnKeys: ["NameTp", "NameTp"],
    keyForBe: "datapointName",
    key: "name",
  },
  datapointType: {
    matchKey: "Type",
    returnKeys: ["Type", "Type"],
    keyForBe: "datapointType",
    key: "datapointType",
  },
  dataPointUiGroup: {
    matchKey: "Category",
    returnKeys: ["Category", "Category"],
    keyForBe: "dataPointUiGroup",
    key: "group",
  },
  supported: {
    matchKey: "supported",
    returnKeys: ["supported", "supported"],
    keyForBe: "supported",
    key: "supported",
  },
  cdn: {
    matchKey: "collectorName",
    returnKeys: ["collectorName", "appCollectorId"],
    keyForBe: "appCollector",
    key: "cdn",
  },
};

export const getUniqueByMatchKey = (
  array,
  matchKey,
  keyMappingClMgmnt,
  type,
) => {
  const mapping = Object.values(keyMappingClMgmnt).find(
    (item) => item.matchKey === matchKey,
  );
  if (!mapping) return [];

  const [labelKey, idKey] = mapping.returnKeys;
  const seenIds = new Set();
  const seenNames = new Set();

  return array?.reduce((acc, item) => {
    const name = item?.[labelKey]?.value?.trim();
    const idRaw = item?.[idKey]?.value;
    const id = typeof idRaw === "string" ? idRaw.trim() : idRaw;

    // Skip if name or id is "--", empty, or null/undefined
    if (
      !name ||
      name === "--" ||
      id === "--" ||
      id === null ||
      id === undefined
    )
      return acc;

    // Skip duplicates
    if ((id && seenIds.has(id)) || seenNames.has(name)) return acc;

    if (id) seenIds.add(id);
    seenNames.add(name);

    acc.push({
      key: mapping.keyForBe,
      name,
      id,
      type,
    });

    return acc;
  }, []);
};

export const getUniqueCountByType = (array, type) => {
  const seen = new Set();

  array?.forEach((item) => {
    const value = item?.[type]?.value;

    if (
      typeof value === "string" &&
      value.trim() !== "" &&
      value.trim() !== "--"
    ) {
      seen.add(value.trim());
    }
  });

  return seen?.size;
};

export const generateUniqueListsByType = (dataList, keyMapping) => {
  const result = {};

  Object.keys(keyMapping).forEach((labelKey) => {
    const mapping = keyMapping[labelKey];

    const uniqueList = getUniqueByMatchKey(
      dataList,
      mapping?.matchKey,
      keyMapping,
      mapping?.keyForBe,
    );

    result[labelKey] = uniqueList
      ?.map((item) => item.name)
      ?.filter((name) => !!name);
  });

  return result;
};

export const disableConfirmPopUpdetails = (
  dialogDetails,
  popUpModule,
  collectorDetails,
) => {
  switch (popUpModule) {
    case "collMgmnt":
      return {
        popupTitle:
          dialogDetails?.type === "application"
            ? `Disable the ${dialogDetails?.name} collector?`
            : dialogDetails?.type === "mediaPlayer"
            ? `Disable the ${dialogDetails?.name} media player adapter?`
            : dialogDetails?.type === "adFramework"
            ? `Disable the ${dialogDetails?.name} ad framework extension?`
            : `Disable the ${dialogDetails?.name} collector? `,
        description:
          dialogDetails?.type === "application"
            ? "Disabling the collector will remove it and its media player adapters and ad framework extensions from the list of possible collectors to configure and disable associated collector configurations that are not attached to a data pipe. No impact to associated collector configurations that are currently attached to a data pipe."
            : dialogDetails?.type === "mediaPlayer"
            ? `Disabling the media player adapter will remove it and its ad framework extensions from the list of possible media player adapters to configure for ${collectorDetails?.application?.name} and disable associated collector configurations that are not attached to a data pipe. No impact to associated collector configurations that are currently attached to a data pipe.`
            : dialogDetails?.type === "adFramework"
            ? `Disabling the ad framework extension will remove it from the list of possible ad framework extensions to configure for ${collectorDetails?.adFramework?.mediaPlayerName} and disable associated collector configurations that are not attached to a data pipe. No impact to associated collector configurations that are currently attached to a data pipe.`
            : "Disabling the collector will remove it and its media player adapters and ad framework extensions from the list of possible collectors to configure and disable associated collector configurations that are not attached to a data pipe. No impact to associated collector configurations that are currently attached to a data pipe.",
        confirmSentence: "To proceed, type disable below.",
        confirmWord: "disable",
        confirmButtonText: "confirm",
      };
    default:
      break;
  }
};

export const isDeprecatedWithoutSupported = (sel) =>
  sel?.NameTp?.deprecated && sel?.supported?.value === "No";
